import React, { useEffect, useState } from "react";
import "../css/PasswordPolicyChecker.css";

/**
 * A component that displays and validates the password policy.
 *
 * @param {string} password - The current password input value.
 * @param {string} confirmPassword - The current confirm password input value.
 * @param {Function} onPasswordValidityChange - A callback to pass the updated validity to the parent.
 * @returns {JSX.Element} The rendered PasswordPolicy component.
 */
const PasswordPolicyChecker = ({
  password,
  confirmPassword,
  onPasswordValidityChange,
}) => {
  const [passwordPolicy, setPasswordPolicy] = useState({
    isLengthValid: false,
    hasUppercase: false,
    hasLowercase: false,
    hasNumber: false,
    hasSymbol: false,
    isMatch: false,
  });

  const validatePassword = () => {
    const policy = {
      isLengthValid: password.length >= 8,
      hasUppercase: /[A-Z]/.test(password),
      hasLowercase: /[a-z]/.test(password),
      hasNumber: /\d/.test(password),
      hasSymbol: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      isMatch: password === confirmPassword && password.length > 0,
    };

    setPasswordPolicy(policy);

    // send the validity status back to the parent
    const isValid = Object.values(policy).every(Boolean);
    onPasswordValidityChange(isValid);
  };

  useEffect(() => {
    // validate password whenever it or confirmPassword changes
    validatePassword();
  }, [password, confirmPassword]);

  return (
    <div className="PasswordPolicyChecker">
      <h3>password must:</h3>
      <ul>
        <li
          style={{
            color: passwordPolicy.isLengthValid ? "#59CD90" : "#EE6352",
          }}
        >
          be at least 8 characters long
        </li>
        <li
          style={{ color: passwordPolicy.hasUppercase ? "#59CD90" : "#EE6352" }}
        >
          contain at least one uppercase letter
        </li>
        <li
          style={{ color: passwordPolicy.hasLowercase ? "#59CD90" : "#EE6352" }}
        >
          contain at least one lowercase letter
        </li>
        <li style={{ color: passwordPolicy.hasNumber ? "#59CD90" : "#EE6352" }}>
          contain at least one number
        </li>
        <li style={{ color: passwordPolicy.hasSymbol ? "#59CD90" : "#EE6352" }}>
          contain at least one of the following: @#$%^&+=!
        </li>
        <li style={{ color: passwordPolicy.isMatch ? "#59CD90" : "#EE6352" }}>
          match
        </li>
      </ul>
    </div>
  );
};

export default PasswordPolicyChecker;
